import React, { memo } from 'react'
import { Box } from '@material-ui/core'
import PropTypes from 'prop-types'
import { FLEX } from '@v4/constants/quiz'
import SubmitButton from '../../components/SubmitButton'
import { usePlaceholder } from './Placeholder.hooks'

const Placeholder = props => {
	const [{ pending, justify, editable, buttonLabel }, { handleSubmit, handleButtonChange }] = usePlaceholder(props)

	return (
		<Box className="q-text-button-container" display="flex" mt={3.7} justifyContent={justify}>
			<SubmitButton
				loading={pending}
				className="q-text-button"
				onClick={handleSubmit}
				onChange={handleButtonChange}
				editable={editable}
			>
				{buttonLabel}
			</SubmitButton>
		</Box>
	)
}
Placeholder.propTypes = {
	questionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onClick: PropTypes.func,
	justify: PropTypes.oneOf(Object.values(FLEX)),
	pending: PropTypes.bool,
	title: PropTypes.node,
}

Placeholder.defaultProps = {
	pending: false,
	justify: FLEX.START,
	onClick: () => {},
	title: null,
}

export default memo(Placeholder)
